import Vue from "vue";

export const apiPost = async (url, { ...data }, validator = null) => {
  if (validator) {
    validator.errors.clear();
    validator.reset();
  }
  return await Vue.axios
    .post(url, { ...data })
    .then(res => {
      return Promise.resolve(res.data);
    })
    .catch(error => {
      if (validator) {
        for (let field in error.response.data.errors) {
          validator.errors.add({
            field: field,
            msg: error.response.data.errors[field][0]
          });
        }
      }
      Vue.nextTick(function() {
        const el = document.querySelector("main .error--text:first-of-type");
        //TODO: Fix scroll beaviour with better solution also for dialog
        // if(!el){
        //   el = document.querySelector(".v-dialog .error--text:first-of-type");
        // }
        if (el) {
          el.scrollIntoView();
        }
      });
      throw error;
    });
};
